/**
 * Created by lu on 2018/5/10.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent: nb.model.List,
    method: {
        init: function () {
            this.onChange('items', function (inEvent, inItems) {
                var items = inItems || [];
                if (items && items.length > 0) {
                    nb.model.onChange('changeLanguageReady', function (inEvent, inKey) {
                        var itemText = this.get('itemText');
                        if (itemText && typeof itemText === 'object') {
                            $.each(items, function (inIndex, inItem) {
                                inItem.setOpts(itemText);
                                inItem.set('dataReady', true, {skipSameValue: false});
                            });
                        }else {
                            $.each(items, function (inIndex, inItem) {
                                inItem.set('dataReady', true, {skipSameValue: false});
                            });
                        }
                    }, this);
                }
            }, this);
        },
        _getItemModel: function (inIndex) {
            var items = this.get('items') || [];
            return items[inIndex];
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/list/List.js
// module id = 4
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39